if (window.location.pathname === "/cart") {
    window.location.href = "/?cart=open";
}

var isMobile = false;
if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) )
    isMobile = true;
else
    isMobile = false;

var wSize = window.innerWidth;
var hSize = window.innerHeight;

var hideAnnouncement = false;
var lastScrollTop = 0;

$(document).ready(function() {

    wSize = window.innerWidth;
    hSize = window.innerHeight;

    $('[data-aos]').addClass('aos-init');

    $("#async-you-may-also-like .owl-carousel").owlCarousel({
        items: 3,
        dots: false,
        nav: true,
        loop: true,
        margin: 50,
        smartSpeed: 500,
        navText: ['<i class="fa-solid fa-chevron-left"></i>', '<i class="fa-solid fa-chevron-right"></i>'],
        responsive: {
            0 : {
                items: 1,
                margin: 20,
                dots: true,
                nav: false,
            },
            768 : {
                items: 2,
                margin: 30,
                dots: true,
                nav: false,
            },
            1280 : {
                items: 3,
                margin: 30,
                dots: false,
                nav: true,
            },
            1366 : {
                items: 3,
                margin: 40,
                dots: false,
                nav: true,
            },
            1440 : {
                items: 3,
                margin: 40,
                dots: false,
                nav: true,
            },
            1536 : {
                items: 3,
                margin: 50,
                dots: false,
                nav: true,
            }
        }
    });

    async_header();
    async_header_init();
});

$(window).scroll(function() {
    $('.aos-init').each(function() {
        let boxTop = $(this).offset().top;
        let boxBottom = boxTop + $(this).outerHeight();
        let viewportTop = $(window).scrollTop();
        let viewportBottom = viewportTop + $(window).height();

        if (boxTop < viewportBottom && boxBottom > viewportTop) {
            $(this).addClass('aos-animate');
        }
    });

    async_header();
});

function async_header() {
    let currentScrollTop = $(this).scrollTop();
    let hHeight = $('.async-header').innerHeight();
    let aHeight = $('.async-header .announcement-bar').innerHeight();

    if ($('.async-header .announcement-bar').css('display') === 'block') {
        if (currentScrollTop > lastScrollTop) {
            if ($(window).scrollTop() >= (0.5 * $(window).height())) {
                $('.async-header').css('top', `-${hHeight}px`);
                $('.async-header .nav-buttons').css('top', `${hHeight-aHeight}px`);
            }
        }
        else if (currentScrollTop < lastScrollTop) {
            if (hideAnnouncement) {
                $('.async-header').css('top', `-${aHeight}px`);
            }
            else {
                $('.async-header').css('top', `0`);
            }
            $('.async-header .nav-buttons').css('top', '0');
        }
    
        if (hideAnnouncement) {
            $('.async-nav-mobile .nav-mobile-items').css('padding-top', `calc(${hHeight-aHeight}px + 20px)`);
        }
        else {
            $('.async-nav-mobile .nav-mobile-items').css('padding-top', `calc(${hHeight}px + 20px)`);
        }
    }
    else {
        if (currentScrollTop > lastScrollTop) {
            if ($(window).scrollTop() >= (0.5 * $(window).height())) {
                $('.async-header').css('top', `-${hHeight}px`);
                $('.async-header .nav-buttons').css('top', `${hHeight}px`);
            }
        }
        else if (currentScrollTop < lastScrollTop) {
            $('.async-header').css('top', `0`);
            $('.async-header .nav-buttons').css('top', '0');
        }

        $('.async-nav-mobile .nav-mobile-items').css('padding-top', `calc(${hHeight}px + 20px)`);
    }

    lastScrollTop = currentScrollTop;
}

function async_header_init() {
    let hHeight = $('.async-header').innerHeight();

    if ($('#your-product-bike .product-gallery').length > 0) {
        $('#your-product-bike .product-gallery').css('padding-top', `calc(20px + ${hHeight}px)`);

        if (wSize >= 1280) {
            $('#your-product-bike .product-info').css('padding-top', `calc(20px + ${hHeight}px)`);
        }
        else {
            $('#your-product-bike .product-info').css('padding-top', '20px');
        }
        
        $('#gallery-expand .container').css({
            'height': `calc(100% - ${hHeight}px)`,
            'margin-top': `${hHeight}px`
        });
    }

    if ($('#async-product-all-section-1 .section-content').length > 0) {
        $('#async-product-all-section-1 .section-content').css('padding-top', `calc(20px + ${hHeight}px)`);
    }
}

$(window).on('resize', function(){
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) )
        isMobile = true;
    else
        isMobile = false;
    
    wSize = window.innerWidth;
    hSize = window.innerHeight;

    iFrameSize();
    async_header();
    async_header_init();
});

$('.announcement-close').on('click', function() {
    hideAnnouncement = true;

    let hHeight = $('.async-header').innerHeight();
    let aHeight = $('.async-header .announcement-bar').innerHeight();

    $('.async-header').css('top', `-${aHeight}px`);

    if ($('#your-product-bike .product-gallery').length > 0) {

        let padding = hHeight - aHeight;

        $('#your-product-bike .product-gallery').css('padding-top', `calc(20px + ${padding}px)`);

        if (wSize >= 1280) {
            $('#your-product-bike .product-info').css('padding-top', `calc(20px + ${padding}px)`);
        }
        else {
            $('#your-product-bike .product-info').css('padding-top', '20px');
        }
        
        $('#gallery-expand .container').css({
            'height': `calc(100% - ${padding}px)`,
            'margin-top': `${padding}px`
        });
    }

    $('.async-nav-mobile .nav-mobile-items').css('padding-top', `calc(${hHeight-aHeight}px + 20px)`);

    if ($('#async-product-all-section-1 .section-content').length > 0) {
        let padding = hHeight - aHeight;
        $('#async-product-all-section-1 .section-content').css('padding-top', `calc(20px + ${padding}px)`);
    }
});

$('.back-to-top').on('click', function() {
    $('html, body').animate({scrollTop: 0}, 300);
});

$('.async-header .nav-toggle').on('click', function() {
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).hasClass('active') ? 'true' : 'false');

    let aHeight = $('.async-header .announcement-bar').innerHeight();

    if (hideAnnouncement)
        $('.async-header').css('top', `-${aHeight}px`);
    else
        $('.async-header').css('top', '0');

    $('.async-header .nav-buttons').css('top', '0');

    if ($(this).hasClass('active')) {
        $('i', this).removeClass('fa-bars').addClass('fa-xmark');
        $('.async-nav-mobile').css('right', '0');
        $('html, body').css('overflow-y', 'hidden');

        $('.async-nav-mobile .nav-mobile-items').scrollTop(0);
    }
    else {
        $('i', this).removeClass('fa-xmark').addClass('fa-bars');
        $('.async-nav-mobile').css('right', '-100%');
        $('html, body').css('overflow-y', 'visible');
    }
});

function calculatePolygon5($element) {
    let elementHeight = $element.outerHeight();
    let viewportHeight = $(window).height();
    
    let elementOffset = $element.offset();
    let elementTop = elementOffset.top - $(window).scrollTop();
    let elementBottom = elementTop + elementHeight;
    
    let scrollPercentage = Math.min(100, Math.max(0, (elementBottom - viewportHeight) / elementHeight * 100));
    
    let firstValue = 15 - (scrollPercentage * 15 / 100);
    let secondValue = 85 + (scrollPercentage * 15 / 100);

    return [Math.max(0, firstValue), Math.min(100, secondValue)];
}

function calculateMiddlePercentage($element) {
    let elementHeight = $element.outerHeight();

    let viewportHeight = $(window).height();

    let elementOffset = $element.offset();
    let elementTop = elementOffset.top - $(window).scrollTop();

    let middleVisibility = (viewportHeight / 2 - elementTop - elementHeight / 2) / (viewportHeight / 2 + elementHeight / 2) * 100;

    middleVisibility = Math.min(100, Math.max(-100, middleVisibility));

    return middleVisibility;
}

function calculateSectionPercentage($element) {
    let elementHeight = $element.outerHeight();
    let viewportHeight = $(window).height();
    
    let elementOffset = $element.offset();
    let elementTop = elementOffset.top - $(window).scrollTop();
    let elementBottom = elementTop + elementHeight;
    
    let scrollPercentage = Math.min(100, Math.max(0, (elementBottom - viewportHeight) / elementHeight * 100));

    return scrollPercentage;
}

function iFrameSize() {
    let width = $('.modal-youtube iframe').width();
    let height = $('.modal-youtube iframe').height();

    $('.modal-youtube .modal-close').css({
        'left': 'calc(50% + '+width/2+'px)',
        'top': 'calc(50% - '+height/2+'px)',
        'opacity': '1'
    });
}

$('.modal-youtube .modal-close').on('click', function() {
    $('.modal-youtube').hide();

    $('html').css('overflow-y', 'auto');

    $('.modal-youtube .modal-close').css({
        'opacity': '0'
    });
    
    $('.modal-youtube iframe').remove();
});

$('.btn-yt').on('click', function() {
    let link = $(this).data('yt');
    const iframe = `<iframe src="${link}"  title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`;
    $('.modal-youtube').append(iframe);

    setTimeout(iFrameSize, 300);
    
    $('html').css('overflow-y', 'hidden');

    $('.modal-youtube').show();
});

$('.async-header .nav-item').on('mouseover', function() {
    megaMenu_open($(this).data('mega'));
})

$('.async-header .mega-menu').on('mouseleave', function() {
    megaMenu_close();
})

function megaMenu_open(selector) {
    if (typeof selector != 'undefined') {

        megaMenu_close();

        let $selectors = $(`.async-header .mega-menu [data-selector="${selector}"]`);
        $selectors.css('display', 'block');

        let count = $('.async-header .mega-menu .mega-selector[style*="display: block"]').length;
    
        if (count > 0) {
            $('.async-header .mega-menu').show();

            let selector = $('.async-header .mega-menu .mega-selector[style*="display: block"]').attr('data-selector');
            $(`.async-header .nav-item[data-mega="${selector}"] i`).css('transform', 'rotate(-180deg)');
        }
    }
    else {
        megaMenu_close();
    }
}

function megaMenu_close() {
    $('.async-header .mega-menu').hide();
    $('.async-header .mega-menu .mega-selector').css('display', 'none');
    $('.async-header .nav-item i').css('transform', 'rotate(0deg)');
}

$('.async-nav-mobile .nav-mobile-item').on('click', function() {

    $('.async-nav-mobile .nav-mobile-item i').css('transform', 'rotate(0deg)');
    $('.async-nav-mobile .nav-mobile-item').attr('aria-expanded', 'false');
    $('.async-nav-mobile .mega-menu').hide();

    let selector = $(this).data('mega');

    let toggle = $('i', this);
    let transformStyle = toggle.css('transform');

    if (transformStyle === 'matrix(-1, 0, 0, -1, 0, 0)') {
        toggle.css('transform', 'rotate(0deg)');
        $(`.async-nav-mobile .mega-menu[data-m-selector="${selector}"]`).hide();
    } else {
        toggle.css('transform', 'rotate(-180deg)');
        $(this).attr('aria-expanded', 'true');
        $(`.async-nav-mobile .mega-menu[data-m-selector="${selector}"]`).show();
    }
});
